module.exports = __webpack_public_path__ + "img/1_B.fea2c90f.png";